import React, { useState } from "react";
import projectData from "../data/project";

const Project = () => {
  const [projects, setProjects] = useState(projectData);

  return (
    <div
      className="py-[64px] bg-black bg-gradient-to-tl from-zinc-900 via-zinc-400/10 to-zinc-900 space-y-2"
      id="projects"
    >
      <h3 className="text-zinc-100 text-center text-bold text-2xl font-bold uppercase">
        Projects
      </h3>
      <p className="text-italics text-zinc-400 text-center mb-6">
        Awesome projects I've done
      </p>
      <div className="grid grid-cols-1 gap-6 p-6 max-w-7xl grid-rows-[masonary] mx-auto justify-center items-center md:gap-6 md:grid-cols-2">
        {projects.map((project) => (
          <div
            className="grid grid-cols-1 lg:grid-cols-2 p-4 rounded-lg overflow-hidden gap-10 items-center md:first:grid-cols-2 md:first:col-span-2 text-left shadow-sm shadow-zinc-500/50 group"
            key={project.name}
          >
            <div className="space-y-2">
              <div className="w-full text-sm space-y-2">
                <h3 className="text-zinc-200 font-bold uppercase">
                  {project.name}
                </h3>
                <p>{project.desc}</p>
                <p>{project.lang}</p>
                <div className="space-x-2">
                  <a
                    href={project.github}
                    target="_blank"
                    aria-label="github"
                    rel="noopener"
                    className="hover:bg-zinc-800 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Github
                  </a>
                  <a
                    href={project.live}
                    target="_blank"
                    aria-label="live"
                    rel="noopener"
                    className="text-zinc-500 hover:bg-zinc-800 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Live
                  </a>
                </div>
              </div>
            </div>
            <img
              src={project.image}
              alt={project.name}
              width="100%"
              height="auto"
              className="hidden md:group-first:block lg:block rounded-lg"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Project;